import './audioplayer.less';
import Utils from '@packages/utils/utils.js'

var eStart = Utils.support.touch ? 'touchstart' : 'mousedown';
var eMove = Utils.support.touch ? 'touchmove' : 'mousemove';
var eEnd = Utils.support.touch ? 'touchend' : 'mouseup';

// 记录页面上所有的音频播放器
window.audioArr = [];
// 暂停所有正在播放的音频
window.pausePlayingAudio = function () {
  for (var i = 0; i < window.audioArr.length; i++) {
    if (Utils.hasClass(window.audioArr[i].player, 'audio-playing')) {
      window.audioArr[i].audio.pause();
      Utils.removeClass(window.audioArr[i].player, 'audio-playing');
    }
  }
}

var audioPlayer = function (element, options) {
  this.element = typeof element === 'string' ? document.querySelector(element) : element;
  this.settings = {
    debug: false
  }
  for (var i in options) {
    this.settings[i] = options[i];
  }
  this.init();
}

audioPlayer.prototype = {
  init: function () {
    var self = this;

    // 如果不是audio标签,则不再往下执行
    if (this.element.tagName.toLowerCase() !== 'audio') {
      return false;
    }

    if (self.settings.debug) {
      Utils._createDebug();
    }

    self.initAudio();
    self.audio = this.element;
    self.createBufferedTimer();
    self.player = self.createPlayer();

    self.timeCurrent.innerText = self.secondsToTime(0);
    self.timeTotal.innerText = self.secondsToTime(0);
    self.element.parentNode.appendChild(self.player);
    self.element.parentNode.removeChild(self.element)
    self.eventAttach();

    window.audioArr.push({
      audio: self.audio,
      player: self.player
    });
  },
  // 初始化音频参数
  initAudio: function () {
    var self = this;
    var $this = self.element;
    self.audioFile = $this.getAttribute('src');
    // 暂时未有使用,待完善
    // self.isAutoPlay = $this.getAttribute('autoplay');
    // self.isAutoPlay = self.isAutoPlay === '' || self.isAutoPlay === 'autoplay' ? true : false;
    // self.isLoop = $this.getAttribute('loop');
    // self.isLoop = self.isLoop === '' || self.isLoop === 'loop' ? true : false;
    // 暂时未有使用,待完善
    self.isSupport = false;
    if (typeof self.audioFile === 'undefined') {
      $this.getElementsByTagName('source').each(function () {
        self.audioFile = this.getAttribute('src');
      });
    }
  },
  // 创建自定义样式播放器
  createPlayer: function () {
    var self = this;
    var html = '';
    html += '<div class="audio-switch">';
    html += '<i class="icon-audio-switch"></i>';
    html += '</div>';
    html += '<div class="audio-detail">';
    if (self.settings.title) {
      html += '<h3 class="audio-detail-title">' + self.settings.title + '</h3>';
    }
    if (self.settings.tips) {
      html += '<p class="audio-detail-tips">' + self.settings.tips + '</p>';
    }
    html += '<div class="audio-progress-wrap">';
    html += '<div class="audio-progress">';
    html += '<div class="audio-progress-buffer"></div>';
    html += '<div class="audio-progress-playing"></div>';
    html += '</div>';
    html += '<div class="audio-progress-handler"><div class="audio-handler-circle"></div></div>';
    html += '</div>';
    html += '<div class="audio-length">';
    html += '<p class="audio-length-current">00:00</p>';
    html += '<p class="audio-length-total">00:00</p>';
    html += '</div>';
    html += '</div>';

    var player = document.createElement('div');
    player.className = 'audio-wrap';
    player.innerHTML = html;

    self.theBar = player.querySelector('.audio-progress-wrap');
    self.barPlaying = player.querySelector('.audio-progress-playing');
    self.barBuffer = player.querySelector('.audio-progress-buffer');
    self.barHandler = player.querySelector('.audio-progress-handler');
    self.timeCurrent = player.querySelector('.audio-length-current');
    self.timeTotal = player.querySelector('.audio-length-total');

    if (self.settings.title && self.settings.tips) {
      // 不做处理
    } else if (!self.settings.title && !self.settings.tips) {
      player.querySelector('.audio-detail').style.marginTop = '22px';
    } else if (self.settings.title && !self.settings.tips) {
      player.querySelector('.audio-detail').style.marginTop = '-7px';
    } else if (!self.settings.title && self.settings.tips) {
      player.querySelector('.audio-detail').style.marginTop = '6px';
    }

    return player;
  },
  // 创建缓冲进度条定时器
  createBufferedTimer: function () {
    // readyState状态值
    // 0 = HAVE_NOTHING - 没有关于音频/视频是否就绪的信息
    // 1 = HAVE_METADATA - 关于音频/视频就绪的元数据
    // 2 = HAVE_CURRENT_DATA - 关于当前播放位置的数据是可用的，但没有足够的数据来播放下一帧/毫秒
    // 3 = HAVE_FUTURE_DATA - 当前及至少下一帧的数据是可用的
    // 4 = HAVE_ENOUGH_DATA - 可用数据足以开始播放

    var self = this;
    if (!self.bufferedTimer) {
      self.bufferedTimer = setInterval(function () {
        if (self.audio.buffered && self.audio.duration && self.audio.readyState >= 3) {
          self.barBuffer.style.width = (self.audio.buffered.end(0) / self.audio.duration) * 100 + '%';
          if (self.audio.buffered.end(0) >= self.audio.duration) {
            clearInterval(self.bufferedTimer);
            self.bufferedTimer = null;
          }
        }
      }, 200);
    }
  },
  // 事件绑定
  eventAttach: function () {
    var self = this;

    // Chrome事件顺序: loadedmetadata(duration开始有值)、loadeddata
    // Chrome点击播放: play、playing、timeupdate
    // chrome点击暂停: pause
    // Chrome结束播放: ended

    // IOS事件顺序: loadedmetadata(duration开始有值)
    // IOS点击播放: play、loadeddata(仅第一次)、playing、timeupdate
    // IOS点击暂停: pause
    // IOS结束播放: ended

    // Android事件顺序:loadedmetadata(部分duration开始有值,Galaxy Note3 Lite 4G 4.3)、loadeddata、timeupdate
    // Android点击播放: play、playing、timeupdate(部分duration开始有值,vivo X5S L 4.4.4)
    // Android点击暂停: pause
    // Android结束播放: ended

    // 当元数据（比如分辨率和时长）被加载时运行的脚本。
    self.audio.addEventListener('loadedmetadata', function () {
      self.settings.debug && Utils._appendDebug('p', 'loadedmetadata' + self.audio.duration)
      self.setTimeTotal(self.audio.duration);
    });
    // 当媒介数据已加载时运行的脚本。
    self.audio.addEventListener('loadeddata', function () {
      self.settings.debug && Utils._appendDebug('p', 'loadeddata' + self.audio.duration);
      self.setTimeTotal(self.audio.duration);
    });
    // 当媒介已开始播放时运行的脚本。
    self.audio.addEventListener('playing', function () {
      self.settings.debug && Utils._appendDebug('p', 'playing' + self.audio.duration);
      self.setTimeTotal(self.audio.duration);
    });
    // 当播放位置改变时（比如当用户快进到媒介中一个不同的位置时）运行的脚本。
    self.audio.addEventListener('timeupdate', function () {
      self.setTimeTotal(self.audio.duration);
      self.timeCurrent.innerText = self.secondsToTime(self.audio.currentTime);
      var percentage = (self.audio.currentTime / self.audio.duration) * 100 + '%';
      self.barPlaying.style.width = percentage;
      self.barHandler.style.left = percentage;
    });
    // 当媒介已到达结尾时运行的脚本（可发送类似“感谢观看”之类的消息）。
    self.audio.addEventListener('ended', function () {
      self.settings.debug && Utils._appendDebug('p', 'ended');
      Utils.removeClass(self.player, 'audio-playing');
      if (self.settings.autoplay && (window.audioArr.length > (self.settings.index + 1))) {
        window.pausePlayingAudio();
        Utils.addClass(window.audioArr[self.settings.index + 1].player, 'audio-playing');
        window.audioArr[self.settings.index + 1].audio.play();
      }
    });
    // 当媒介已就绪可以开始播放时运行的脚本。
    self.audio.addEventListener('play', function () {
      self.settings.debug && Utils._appendDebug('p', 'play');
    });
    // 当媒介被用户或程序暂停时运行的脚本。
    self.audio.addEventListener('pause', function () {
      self.settings.debug && Utils._appendDebug('p', 'pause');
    });

    self.theBar.addEventListener(eStart, function (e) {
      self.adjustCurrentTime(e);
      self.theBar.addEventListener(eMove, function (e) {
        self.adjustCurrentTime(e);
      });
    })
    self.theBar.addEventListener(eEnd, function () {
      self.theBar.removeEventListener(eMove, null);
    });

    self.barHandler.addEventListener(eStart, function (e) {
      self.barHandler.addEventListener(eMove, function (e) {
        self.adjustCurrentTime(e);
        // 阻止事件冒泡到theBar move事件上
        // 如不加会在IOS 8会产生影响,导致无法滑动
        e.preventDefault();
        e.stopPropagation();
      });
    });
    self.barHandler.addEventListener(eEnd, function () {
      self.barHandler.removeEventListener(eMove, null);
    });

    self.player.querySelector('.audio-switch').addEventListener('click', function () {
      if (Utils.hasClass(self.player, 'audio-playing')) {
        Utils.removeClass(self.player, 'audio-playing');
        self.audio.pause();
      } else {
        window.pausePlayingAudio();
        Utils.addClass(self.player, 'audio-playing');
        self.audio.play();
      }
    });
  },
  // 调节当前播放时间
  adjustCurrentTime: function (e) {
    var self = this;
    if (e.originalEvent) e = e.originalEvent;
    var theRealEvent = Utils.support.touch ? e.touches[0] : e;
    self.audio.currentTime = Math.round((self.audio.duration * (theRealEvent.pageX - self.theBar.offsetLeft)) / self.theBar.clientWidth);
  },
  // 设置总时间
  setTimeTotal: function (duration) {
    var self = this;
    if (duration > 0 && !self.timeTotal.getAttribute('duration')) {
      self.timeTotal.setAttribute('duration', duration);
      self.timeTotal.innerText = self.secondsToTime(self.audio.duration);
    }
  },
  // 将秒转换成固定格式的时间
  secondsToTime: function (secs) {
    var hours = Math.floor(secs / 3600);
    var minutes = Math.floor(secs % 3600 / 60);
    var seconds = Math.ceil(secs % 3600 % 60);
    return (hours === 0 ? '' : hours > 0 && hours.toString().length < 2 ? '0' + hours + ':' : hours + ':') + (minutes.toString().length < 2 ? '0' + minutes : minutes) + ':' + (seconds.toString().length < 2 ? '0' + seconds : seconds);
  },
  // android 兼容性有问题,需要优化
  canPlayType: function (file) {
    var audioElement = document.createElement('audio');
    return !!(audioElement.canPlayType && audioElement.canPlayType('audio/' + file.split('.').pop().toLowerCase() + ';').replace(/no/, ''));
  }
}
export default audioPlayer;



// WEBPACK FOOTER //
// ./packages/components/audioplayer/audioplayer.js